// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export type DnaSyngoviaIconType =
  | 'at'
  | 'syngovia'
  | 'us'
  | 'ct'
  | 'xp_rf'
  | 'xp_su'
  | 'xp_ur'
  | 'xp_wh'
  | 'mr'
  | 'mi'
  | 'printer'
  | 'cd_burner'
  | 'server'
  | 'ris'
  | 'pacs'
  | 'customized'
  | 'workstation'
  | 'dicom_proxy'
  | 'teamplay'
  | 'scanner'
  | 'digital_product'
  | 'unknown';

export class DnaSyngoviaImgIconModel {
  public path = 'assets/syngovia/icons';
  public type: DnaSyngoviaIconType = 'unknown';
  public alt = 'Image Icon for Unknown device';

  public constructor(defintion?: Partial<DnaSyngoviaImgIconModel>) {
    Object.assign(this, defintion);
  }

  get src(): string {
    return `${this.path}/${this.type}.svg`;
  }
}
